var _rect, _text, _text2, _text3, _text4, _line, _circle, _text5, _text6, _text7, _line2, _text8, _circle2, _text9, _text10, _text11, _line3, _text12, _circle3, _text13, _text14, _text15, _line4, _text16, _circle4, _text17, _text18, _text19, _line5, _text20, _circle5, _text21, _text22, _text23, _line6, _text24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase5Fig3Incident273Timeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1040 560",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1040,
    height: 560,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Incident timeline, 2026-07-09")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Five events rendered from the git record. Vertical distance follows elapsed time.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 112,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "GIT RECORD")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 112,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "WHAT CHANGED")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 140,
    x2: 250,
    y2: 508,
    stroke: "#D4DDD6",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 140,
    r: 8,
    fill: "#DC2626"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 145,
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#DC2626"
  }, "19:26:49")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 145,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Breaking merge lands on main")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 164,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "production requests fail with ", /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 600,
    fill: "#DC2626"
  }, "500s"))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 585,
    y1: 140,
    x2: 628,
    y2: 140,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 145,
    fontSize: 13,
    fontWeight: 500,
    fill: "#4A5F56"
  }, "the new code selected a column production did not have")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 196,
    r: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 201,
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#16A34A"
  }, "19:33:34")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 201,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Revert merged")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 220,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "recovery window ", /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 600,
    fill: "#16A34A"
  }, "6m45s"))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 585,
    y1: 196,
    x2: 628,
    y2: 196,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 201,
    fontSize: 13,
    fontWeight: 500,
    fill: "#4A5F56"
  }, "old code serves again, tracking issue filed within a minute")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 352,
    r: 8,
    fill: "#16A34A"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 357,
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "21:36")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 357,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Clean re-land")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 376,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "the change returns through a green pipeline")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 585,
    y1: 352,
    x2: 628,
    y2: 352,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 357,
    fontSize: 13,
    fontWeight: 500,
    fill: "#4A5F56"
  }, "same change, behind the full gate this time")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 436,
    r: 8,
    fill: "#16A34A"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 441,
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "22:42")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 441,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700
  }, "D-022"), " locked")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 460,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "architecture decision recorded and locked")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 585,
    y1: 436,
    x2: 628,
    y2: 436,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 441,
    fontSize: 13,
    fontWeight: 500,
    fill: "#4A5F56"
  }, "schema now applies inside the build, before code serves")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 508,
    r: 8,
    fill: "#16A34A"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 513,
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "+31m")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 513,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontWeight: 700
  }, "#277"), " hardening merged")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 532,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "31 minutes after D-022")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 585,
    y1: 508,
    x2: 628,
    y2: 508,
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 513,
    fontSize: 13,
    fontWeight: 500,
    fill: "#4A5F56"
  }, "force push replaced by committed migrations plus a drift guard")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase5Fig3Incident273Timeline);
export default __webpack_public_path__ + "static/media/case5-fig3-incident-273-timeline.29155781901855d58756ec7113f978e0.svg";
export { ForwardRef as ReactComponent };